import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Register from './pages/Register';
import GameSimulation from './pages/GameSimulation';
import Manual from './pages/Manual';
import Library from './pages/Library';
import Community from './pages/Community';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gradient-to-b from-blue-50 to-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
            <Route path="/registro" element={<Register data-id="element-8" />} data-id="element-7" />
            <Route path="/juego" element={<GameSimulation data-id="element-10" />} data-id="element-9" />
            <Route path="/manual" element={<Manual data-id="element-12" />} data-id="element-11" />
            <Route path="/biblioteca" element={<Library data-id="element-14" />} data-id="element-13" />
            <Route path="/comunidad" element={<Community data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
        <Footer data-id="element-17" />
      </div>
    </Router>;
}